import { z } from "zod";
import { createRequiredEmailSchema, createRequiredStringSchema } from "@/lib/utils/validation/zod";

export type FormValues = z.infer<typeof formSchema>;

export const formSchema = z.object({
  email: createRequiredEmailSchema("email"),
  password: createRequiredStringSchema("password", 50),
});
